export default __webpack_public_path__ + "2f184058af71ed9ba07fb2d29176deb0.jpeg";